import { type SelectItem } from './types'
import { US_TIME_ZONES } from '@terros/common'

export function getTimeZones(current = 'America/Los_Angeles'): SelectItem<string>[] {
  US_TIME_ZONES.add(current)
  const timezones = Array.from(US_TIME_ZONES.keys())

  return timezones.map((time) => {
    return {
      label: time,
      value: time,
    }
  })
}
